var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7811 2.41214C7.09121 1.13475 8.9079 1.13475 9.21801 2.41214C9.41834 3.23732 10.3637 3.62892 11.0889 3.18708C12.2114 2.50311 13.496 3.7877 12.812 4.91024C12.3702 5.63538 12.7618 6.58078 13.587 6.7811C14.8644 7.09121 14.8644 8.9079 13.587 9.21801C12.7618 9.41834 12.3702 10.3637 12.812 11.0889C13.496 12.2114 12.2114 13.496 11.0889 12.812C10.3637 12.3702 9.41834 12.7618 9.21801 13.587C8.9079 14.8644 7.09121 14.8644 6.7811 13.587C6.58078 12.7618 5.63538 12.3702 4.91024 12.812C3.7877 13.496 2.50311 12.2114 3.18708 11.0889C3.62892 10.3637 3.23732 9.41834 2.41214 9.21801C1.13475 8.9079 1.13475 7.09121 2.41214 6.7811C3.23732 6.58078 3.62892 5.63538 3.18708 4.91024C2.50311 3.7877 3.7877 2.50311 4.91024 3.18708C5.63538 3.62892 6.58078 3.23732 6.7811 2.41214Z",
    stroke: "white",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1814 7.99956C10.1814 9.20454 9.20454 10.1814 7.99956 10.1814C6.79457 10.1814 5.81774 9.20454 5.81774 7.99956C5.81774 6.79457 6.79457 5.81774 7.99956 5.81774C9.20454 5.81774 10.1814 6.79457 10.1814 7.99956Z",
    stroke: "white",
    strokeWidth: 1.13,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.1a1476bd15ac0c9fa4e320271e29a913.svg";
export { ForwardRef as ReactComponent };